export default `
	mutation updateAvailability($docId:ID!,$from:AWSDateTime!,$to:AWSDateTime!,$type:UpdateAvailabilityType!) {
		updateAvailability(docId:$docId,from:$from,to:$to,type:$type)
	}
`